.introContent {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.portrait {
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 12px;
}

.bullets {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

.check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--dark-10);
  color: var(--dark-100);
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.allSetContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.checkBadge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--green-10);
  color: var(--dark-100);
  margin-top: 8px;
}

.body {
  max-width: 440px;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 8px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 20px;
  text-align: left;
  border: 1px solid var(--dark-10);
  border-radius: 12px;
  background: none;
  cursor: pointer;

  &:hover {
    background: var(--dark-5);
  }
}

.rowText {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.arrow {
  flex-shrink: 0;
  color: var(--dark-60);
}

.spinner {
  margin-right: 8px;
}

.scheduleForm {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.scheduleControls {
  display: flex;
  gap: 48px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.accounts {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.accountsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.skeletonCard {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  overflow: hidden;
}

.skeletonPoster {
  width: 100%;
  aspect-ratio: 4 / 5;
  border-radius: 0;
}

.skeletonInfo {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
}

.skeletonLine {
  height: 12px;
}
